import { type TypographyCommon, type Variant } from './types'
import { BaseTypography } from './BaseTypography'

type Props = TypographyCommon<{
  /**
   * Set your color
   * @default 'Bold'
   */
  variant?: Variant<'primary' | 'dhlRed' | 'goGreen'>
}>

export const H5 = ({ children, variant = 'primary', ...rest }: Props) => (
  <BaseTypography variant="h5" color={variant} {...rest}>
    {children}
  </BaseTypography>
)
